import { LitElement, html, css } from 'lit';

import './neb-icon';
import { baseStyles } from '../../../packages/neb-styles/neb-styles';
import {
  CSS_SPACING,
  CSS_FONT_WEIGHT_BOLD,
  CSS_COLOR_GREY_1,
  CSS_BORDER_GREY_2,
  CSS_FONT_SIZE_CAPTION,
} from '../../../packages/neb-styles/neb-variables';
import '../../../packages/neb-styles/neb-icons';
import { CSS_FONT_SIZE_HEADER, CSS_SPACING_ROW } from '../../styles';

export const ELEMENTS = {
  patientName: { id: 'patient-name' },
  patientDob: { id: 'patient-dob' },
  patientSummaryDate: { id: 'patient-summary-date' },
  firstVisit: { id: 'first-visit' },
  lastVisit: { id: 'last-visit' },
  nextVisit: { id: 'next-visit' },
  totalVisits: { id: 'total-visits' },
  closeIcon: { id: 'close-icon' },
};

export class NebProgressionOfCareHeader extends LitElement {
  static get properties() {
    return {
      model: { type: Object, reflect: true },
    };
  }

  static get styles() {
    return [
      baseStyles,
      css`
        .patient-header {
          padding: ${CSS_SPACING};
          border-bottom: ${CSS_BORDER_GREY_2};
          position: relative;
        }

        .patient-name {
          font-weight: ${CSS_FONT_WEIGHT_BOLD};
          font-size: ${CSS_FONT_SIZE_HEADER};
          margin-bottom: 5px;
        }

        .patient-dob,
        .patient-summary-date {
          color: ${CSS_COLOR_GREY_1};
          font-size: ${CSS_FONT_SIZE_CAPTION};
          margin-bottom: 5px;
        }

        .visit-info {
          display: flex;
          flex-wrap: wrap;
          font-size: ${CSS_FONT_SIZE_CAPTION};
          margin-top: ${CSS_SPACING};
          gap: ${CSS_SPACING_ROW};
        }

        .visit-row {
          display: flex;
          width: 100%;
          gap: ${CSS_SPACING_ROW};
        }

        .visit-item {
          padding: 1px 10px;
          border-radius: 10px;
          border: ${CSS_BORDER_GREY_2};
          display: flex;
          align-items: center;
          font-weight: ${CSS_FONT_WEIGHT_BOLD};
        }

        .icon {
          width: 12px;
          height: 12px;
          margin-right: 5px;
          fill: ${CSS_COLOR_GREY_1};
        }

        .container-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .icon-close {
          cursor: pointer;
          width: 24px;
          height: 24px;
          fill: ${CSS_COLOR_GREY_1};
        }
      `,
    ];
  }

  constructor() {
    super();
    this.initState();
    this.initHandlers();
  }

  initState() {
    this.model = {
      patientName: '',
      patientDob: '',
      patientAge: '',
      summaryDate: '',
      firstVisit: '',
      lastVisit: '',
      nextVisit: '',
      totalPastVisits: '',
      totalAppointments: '',
    };

    this.onClose = () => {};
  }

  initHandlers() {
    this.handlers = {
      close: () => this.onClose(),
    };
  }

  renderPatientInfo() {
    const { patientName, patientDob, patientAge, summaryDate } = this.model;

    return html`
      <div class="container-header">
        <div id="${ELEMENTS.patientName.id}" class="patient-name">
          ${patientName}
        </div>
        <neb-icon
          id="${ELEMENTS.closeIcon.id}"
          class="icon-close"
          icon="neb:close"
          @click="${this.handlers.close}"
        ></neb-icon>
      </div>

      <div id="${ELEMENTS.patientDob.id}" class="patient-dob">
        DOB: ${patientDob} ${patientAge}
      </div>

      <div id="${ELEMENTS.patientSummaryDate.id}" class="patient-summary-date">
        Summary as of: ${summaryDate || '-'}
      </div>
    `;
  }

  renderVisitInfo() {
    const {
      firstVisit,
      lastVisit,
      nextVisit,
      totalPastVisits,
      totalAppointments,
    } = this.model;

    return html`
      <div class="visit-info">
        <div class="visit-row">
          <div id="${ELEMENTS.firstVisit.id}" class="visit-item">
            <neb-icon class="icon" icon="neb:calendar"></neb-icon>
            First Visit: ${firstVisit || '-'}
          </div>

          <div id="${ELEMENTS.lastVisit.id}" class="visit-item">
            <neb-icon class="icon" icon="neb:calendar"></neb-icon>
            Last Visit: ${lastVisit || '-'}
          </div>
        </div>

        <div class="visit-row">
          <div id="${ELEMENTS.nextVisit.id}" class="visit-item">
            <neb-icon class="icon" icon="neb:calendar"></neb-icon>
            Next Visit: ${nextVisit || '-'}
          </div>

          <div id="${ELEMENTS.totalVisits.id}" class="visit-item">
            <neb-icon class="icon" icon="neb:clock"></neb-icon>
            Total Visits: ${totalPastVisits} of ${totalAppointments}
          </div>
        </div>
      </div>
    `;
  }

  render() {
    return html`
      <div class="patient-header">
        ${this.renderPatientInfo()} ${this.renderVisitInfo()}
      </div>
    `;
  }
}

window.customElements.define(
  'neb-progression-of-care-header',
  NebProgressionOfCareHeader,
);
